import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { DateInput } from "./DateInput";
import { DateFieldProps } from "./DateField.types";

/** Date-only editable field: the shared date picker under the field's label. */
export function DateField({
  label,
  name,
  value,
  onChange,
  disabled,
  required,
  max,
  min,
  error,
  className,
  helpText,
}: DateFieldProps) {
  return (
    <FieldValue label={label} htmlFor={name} required={required} helpText={helpText} error={error} className={className}>
      <DateInput
        id={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        max={max}
        min={min}
        className={fieldControlClass("form-control", error)}
        ariaDescribedBy={fieldDescribedBy(name, helpText, error)}
        ariaInvalid={Boolean(error)}
      />
    </FieldValue>
  );
}
